export default function ResetColorButton({ onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      style={{
        marginLeft: '8px',
        backgroundColor: 'white',
        borderRadius: '4px',
        borderWidth: '1.75px',
        borderColor: '#d9d9d9',
        borderStyle: 'solid',
        cursor: 'pointer',
      }}
    >
      Reset
    </button>
  );
}
